<template>
  <div>
    <div class="paging-wrap">
      <div
        class="load-end"
        style="text-align: center;text-align: center;margin-top: 40px;font-size: 24px;"
        v-if="not_data"
      >--没有数据--</div>
      <div v-else>
        <div id="loading" v-show="loading">
          <div class="loading-img">
            <img
              src="@/assets/images/html/loading.gif"
              style="vertical-align: middle;margin-right: 10px;"
            >正在加载中...
          </div>
        </div>
        <slot/>
      </div>
    </div>
    <div class="fy-pagination" v-if="!not_data">
      <pagination
        :background="background"
        :current-page="current_page"
        :layout="layout"
        :page-size="page_size"
        :total="total"
        @current-change="handleCurrentChange"
        @next-click="handleNextClick"
        @prev-click="handlePrevClick"
      >
        <span class="el-pagination__total">共 {{page_count_d}} 页</span>
      </pagination>
    </div>
  </div>
</template>
<script>
// element-ui
import { pagination } from 'element-ui'
export default {
  name: 'Paging',
  componentName: 'Paging',
  components: {
    pagination
  },
  data () {
    return {
      current_page: this.value,
      page_count_d: this.page_count
    }
  },
  props: {
    /**
     * 显示加载中状态
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * 
     */
    not_data: {
      type: Boolean,
      default: false
    },
    /**
     * 当前页
     */
    value: {
      type: Number,
      default: 1
    },
    /**
     * 页码数
     */
    pager_count: {
      type: Number,
      default: 10
    },
    /**
     * 组件布局，子组件名用逗号分隔
     */
    layout: {
      type: String,
      default: 'prev, pager, next, slot, jumper'
    },
    /**
     * 总页数
     */
    page_count: Number,
    /**
     * 总条目数，必传参数
     */
    total: Number,
    /**
     * 每页显示个数选择器的选项设置
     */
    page_size: {
      type: Number,
      default: 10
    },
    /**
     * 是否为分页按钮添加背景色
     */
    background: {
      type: Boolean,
      default: true
    },

    // 自定义回掉事件
    /**
     * currentPage 改变时会触发
     */
    current_change: {
      type: Function,
      default: function () {
        return {}
      }
    },
    /**
     * 用户点击上一页按钮改变当前页后触发
     */
    prev_click: {
      type: Function,
      default: function () {
        return {}
      }
    },
    /**
     * 用户点击下一页按钮改变当前页后触发
     */
    next_click: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  created () {
    if (!this.page_count) {
      this.page_count_d = Math.ceil(this.total / this.page_size)
    }
  },
  watch: {
    current_page (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.current_page = val
    },
    total (val) {
      if (!this.page_count) {
        this.page_count_d = Math.ceil(this.total / this.page_size)
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.current_page = val
      this.current_change(val)
    },
    handlePrevClick (val) {
      this.prev_click(val)
    },
    handleNextClick (val) {
      this.next_click(val)
    }
  }
}
</script>
<style lang="scss" scope>
#loading {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
}
.paging-wrap {
  position: relative;
}
#loading .loading-img {
  position: relative;
  color: white;
  top: 50%;
  left: 40%;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/page/paging.vue